import {CSSProperties} from "react";
import {ImageStyled} from "./styled";
import {Clickable} from "interfaces";

interface ImageProps extends CSSProperties, Partial<Clickable> {
  src: string;
  size?: number;
}

export const Image: React.FC<ImageProps> = (props) => {
  const {src, size = 80, onClick, ...cssStyle} = props;
  return (
    <ImageStyled
      onClick={onClick}
      src={src || "/images/logo.png"}
      style={{width: size, height: size, ...cssStyle}}
      onError={({currentTarget}) => {
        currentTarget.src = "/images/logo.png";
      }}
    />
  );
};
